import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './LinkBookie.css';

function LinkBookieComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const status = searchParams.get('status') || 'success';
  const message = searchParams.get('message') || '';
  const clubId = searchParams.get('clubId');
  const isSignup = searchParams.get('signup') === '1';

  useEffect(() => {
    // Determine redirect target
    const target = (isSignup && clubId)
      ? `/signup/invite?clubId=${clubId}`
      : '/dashboard';

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(target);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, isSignup, clubId]);

  const isSuccess = status === 'success';

  return (
    <div className="link-bookie-wrapper">
      <div className="link-bookie-container">
        <div className={isSuccess ? 'success-message' : 'error-message'}>
          {isSuccess ? (
            <>
              <div className="success-icon">✓</div>
              <h2>Bookie Account Linked Successfully!</h2>
              <p>
                Your bookie account has been successfully linked to your club.
                You can now start placing bets and tracking your performance.
              </p>
            </>
          ) : (
            <>
              <h2>Registration Issue</h2>
              <p>
                {message || 'There was an issue linking your bookie account. Please try again.'}
              </p>
            </>
          )}

          <p className="redirect-notice">
            Redirecting to dashboard in {countdown} seconds...
          </p>

          <button onClick={() => navigate('/dashboard')} className="btn-primary">
            Go to Dashboard Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default LinkBookieComplete;
